"use client";

import { Skeleton } from "@/shared/components/ui/skeleton";

function ProductCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-[10px] bg-white md:rounded-xl">
      <Skeleton className="aspect-176/235 w-full rounded-none md:aspect-332/443" />
      <div className="space-y-2 p-3">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-4 w-full" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-4 w-14" />
          <Skeleton className="h-3 w-12" />
        </div>
        <Skeleton className="h-3 w-28 md:hidden" />
      </div>
    </div>
  );
}

export function CategorySlugPageSkeleton({ categoryName }: { categoryName: string }) {
  return (
    <div className="bg-[#F5F5F5] min-h-screen">
      <div className="bg-white border-b border-gray-100 py-2">
        <div className="container mx-auto px-6 flex items-center gap-2 text-[11px] font-medium">
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-3 w-3 rounded-full" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-3 rounded-full" />
          <span className="text-[#001F5F]">{categoryName}</span>
        </div>
      </div>

      <Skeleton className="w-full h-[150px] md:h-[250px] rounded-none" />

      <div className="container mx-auto px-6 py-8">
        <div className="flex gap-6">
          <div className="hidden lg:block w-64 shrink-0 space-y-6">
            <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <div className="p-4 border-b border-gray-100 flex items-center justify-between">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-14" />
              </div>
              <div className="p-4 border-b border-gray-100 space-y-3">
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-5/6" />
                <Skeleton className="h-3 w-2/3" />
              </div>
              <div className="p-4 border-b border-gray-100 space-y-3">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-full" />
                <div className="flex items-center gap-2">
                  <Skeleton className="h-7 w-full" />
                  <Skeleton className="h-7 w-full" />
                </div>
              </div>
              <div className="p-4 space-y-3">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-3 w-3/4" />
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-3 w-5/6" />
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5 mb-6">
              {Array.from({ length: 12 }).map((_, i) => (
                <ProductCardSkeleton key={i} />
              ))}
            </div>
            <div className="flex flex-col items-center justify-center gap-3 mb-8">
              <Skeleton className="h-11 w-40 rounded-lg" />
              <Skeleton className="h-3 w-52" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
